import { Link } from '@mui/material'

const CooksProfileLink = (props: {href: string}) => {
  let href = `https://thechefkart.com/cooks/${props.href}/profile`
  return <Link href={href} target={'_blank'} >Go to cook profile</Link>
}

export default CooksProfileLink
